import { AuthTokenStructure } from 'api/types';
import { isFuture } from 'date-fns';

export const isAuthTokenRefreshable = (decodedAuthToken: AuthTokenStructure | null) => {
    if (decodedAuthToken) {
        return isFuture(new Date(decodedAuthToken.sync * 1000));
    }

    return false;
};
